const Fav = ({ data }) => {
  const { inFavour, inCompare, toggleFavour, toggleCompare } = data;
  const favActive = inFavour ? 'active' : '';
  const compActive = inCompare ? 'active' : '';

  return (
    <div className="product__fav">
      <span className="favorite__heart" onClick={toggleFavour}>
        <i className={`icon heart ${favActive} `}></i>
      </span>
      <span className="favorite__chart" onClick={toggleCompare}>
        <i className={`icon chart-two ${compActive}`}></i>
      </span>
    </div>
  );
};

export default Fav;
